export default __webpack_public_path__ + "static/media/gallery_21.0643c581.jpg";